import POUPABOT_EXT_1 from "./POUPABOT_EXT_1";
export default {
  POUPABOT_EXT_1,
};
